import PwTablePanel from './PwTablePanel.jsx';

export default PwTablePanel;
